import { PDFSections } from '@/types';

export function buildResultPdfSections(isEwa: boolean): PDFSections[] {
	const sections = [
		PDFSections.REBA,
		PDFSections.NIOSH,
		PDFSections.KIM_PP,
		PDFSections.KIM_MHO,
		PDFSections.KIM_LHC,
		PDFSections.ACTION_PLANS,
		PDFSections.STRAIN_INDEX,
		PDFSections.NOT_EVALUATED,
		PDFSections.LIBERTY_MUTUAL,
		isEwa && PDFSections.CHARACTERISTICS,
		isEwa && PDFSections.WORK_CONDITIONS
	].filter(Boolean) as PDFSections[];

	return sections;
}
